// extracted by mini-css-extract-plugin
export default {"uploadWrapper":"uploadWrapper___dQgWz","deleteButton":"deleteButton___sB2VI","sideActions":"sideActions___nhrYE"};